export const queryKeys = {
  getCounties: "getCounties",
  getCounty: "getCounty",  
};
